// extracted by mini-css-extract-plugin
export default {"tab":"Tab-module__tab___qLkrc","title":"Tab-module__title___c8DFM","icon":"Tab-module__icon___wDG8z","selected":"Tab-module__selected___mx_qx","mobile":"Tab-module__mobile___OfTrQ"};